import React from 'react'

const ErrorFormNotFilled = () => {
    return (
        <div className='text-sm mt-[0.5rem] text-red-600'>Please fill out all mandatory fields to proceed</div>
    )
}

export default ErrorFormNotFilled